import React from "react";
import {GatsbyImage} from "gatsby-plugin-image";
import Fade from "react-reveal/Fade";

const Image = ({image}) => {
  return (
    <section className='image'>
      <Fade bottom distance='40px'>
        <div className='image__inner'>
          <GatsbyImage image={image.localFile.childImageSharp.gatsbyImageData} alt={image.altText}/>
        </div>
      </Fade>
    </section>
  )
}

export default Image